import * as React from "react";

import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  RiArrowLeftLine,
  RiDeleteBinLine,
  RiFileEditLine,
  RiCalculatorLine,
  RiCheckLine,
} from "react-icons/ri";

import Button from "../../Components/Button";
import Dropzone from "../../Components/Dropzone";
import SidebarRightFinancingRequestNotConnected from "../../Components/SidebarRightFinancingRequestNotConnected";

import { FileExtImg } from "../../Functions/files";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import Logo from "./../../Images/logo_white.png";

import "./FinancingRequestNotConnected.scss";

const initialFormState = {
  cin: [],
  patente: [],
  facture_proforma: [],
  carte_professionnelle: [],
  rne: [],
  releves_bancaires: [],
  facture_sone_de_steg: [],
  certificat_de_degrevement_fiscal: [],
  permis_de_conduire: [],
  rib: [],
  statuts_a_jour: [],
  repartition_du_capital: [],
  pouvoirs_du_gerant: [],
  bilans_et_comptes_annexes: [],
  attestation_agriculture: [],
  titre_de_propriete: [],

  taxe_de_transport: [],
  step: "documents",
};

const FinancingRequestNotConnectedStep2 = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");
  const [requestType, setRequestType] = React.useState("");
  const [fileNameDropzone, setFileNameDropzone] = React.useState({});
  const [removedTitleAgricule, setRemovedTitleAgricule] = React.useState(false);
  const [removedReparationCapital, setRemovedReparationCapital] =
    React.useState(false);
  const [removedPouvoirGerants, setRemovedPouvoirGerants] =
    React.useState(false);

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const convertFileToBase64 = (file, fieldName) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      // `reader.result` contains the Base64-encoded file data
      // const base64String = reader.result.split(",")[1];
      const base64String = reader.result; // Remove the data URL prefix

      handleChangeField(base64String, fieldName); // Set the Base64 string to state
    };

    reader.readAsDataURL(file); // Read the file as a Data URL
  };

  React.useEffect(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "Access-Token": localStorage.getItem(
            process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
          ),
        },
      })
      .then(async (response) => {
        setIsLoading(false);
        setRequestType(response.data?.data?.request_type);

        const documents = response.data?.data?.documents || [];

        for (const element of documents) {
          // const fileName = element.url.split("/").pop();
          const fileNameExtension = element.file_name + element.file_extension;
          setFileNameDropzone((prevState) => ({
            ...prevState, // keep all other key-value pairs
            [element.slug]: fileNameExtension, // update the value of specific key
          }));
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  }, [setIsLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    formData.append(
      "cin",
      valRegister?.carte_professionnelle && valRegister?.cin
    );

    formData.append(
      "patente",
      valRegister?.carte_professionnelle && valRegister?.patente
    );
    formData.append(
      "facture_proforma",
      valRegister?.carte_professionnelle && valRegister?.facture_proforma
    );
    formData.append(
      "carte_professionnelle",
      valRegister?.carte_professionnelle && valRegister?.carte_professionnelle
    );
    formData.append(
      "rne",
      valRegister?.carte_professionnelle && valRegister?.rne
    );
    formData.append(
      "releves_bancaires",
      valRegister?.carte_professionnelle && valRegister?.releves_bancaires
    );
    formData.append(
      "facture_sone_de_steg",
      valRegister?.carte_professionnelle && valRegister?.facture_sone_de_steg
    );
    formData.append(
      "certificat_de_degrevement_fiscal",
      valRegister?.carte_professionnelle &&
        valRegister?.certificat_de_degrevement_fiscal
    );
    formData.append(
      "permis_de_conduire",
      valRegister?.carte_professionnelle && valRegister?.permis_de_conduire
    );
    formData.append(
      "rib",
      valRegister?.carte_professionnelle && valRegister.rib
    );

    // Cas d’un agriculteur
    formData.append(
      "attestation_agriculture",
      valRegister?.carte_professionnelle && valRegister?.attestation_agriculture
    );
    formData.append(
      "titre_de_propriete",
      valRegister?.carte_professionnelle && valRegister?.titre_de_propriete
    );
    formData.append(
      "taxe_de_transport",
      valRegister?.carte_professionnelle && valRegister?.taxe_de_transport
    );

    // Cas d’une entreprise
    formData.append(
      "statuts_a_jour",
      valRegister?.carte_professionnelle && valRegister.statuts_a_jour
    );
    formData.append(
      "repartition_du_capital",
      valRegister?.carte_professionnelle && valRegister.repartition_du_capital
    );
    formData.append(
      "pouvoirs_du_gerant",
      valRegister?.carte_professionnelle && valRegister.pouvoirs_du_gerant
    );
    formData.append(
      "bilans_et_comptes_annexes",
      valRegister?.bilans_et_comptes_annexes &&
        valRegister.bilans_et_comptes_annexes
    );
    formData.append("step", "documents");
    formData.append("request_type", requestType);
    formData.append("titre_de_propriete_deleted", removedTitleAgricule);
    formData.append("repartition_du_capital_deleted", removedReparationCapital);
    formData.append("pouvoirs_du_gerant_deleted", removedPouvoirGerants);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/financing-request/update`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem(
              process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
            ),
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/resume");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const removeElement = (key) => {
    setFileNameDropzone((prevImages) => ({
      ...prevImages,
      [key]: null,
    }));
    if (key === "titre_de_propriete") {
      setRemovedTitleAgricule((prev) => !prev);
    }
    if (key === "repartition_du_capital") {
      setRemovedReparationCapital((prev) => !prev);
    }
    if (key === "pouvoirs_du_gerant") {
      setRemovedPouvoirGerants((prev) => !prev);
    }
  };

  return (
    <div className="layout-app layout-not-connected ">
      <div className="sideBar sideBar-not-connected">
        <Link to="/" className="logo logo-white">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
        <div className="title-sidebar-not-connected active">
          Lancez votre projet Leasing
        </div>
        <div className="menu-sidebar-not-connected">
          <RiCalculatorLine /> Simulations
        </div>
        <div className="menu-sidebar-not-connected active">
          <RiFileEditLine /> Demande de Financement
        </div>
      </div>
      <div className="wrap-app wrap-app-not-connected">
        <div className="topBarNotConnected">
          <Row>
            <Col md={12}>
              <div className="wrapTopBarNotConnected">
                <Link to="/customer-information" className="link-back">
                  <RiArrowLeftLine />
                </Link>

                <div className="title-topBarNot">Documents à Joindres</div>
                <div className="description-topBarNot">
                  Liste des documents nécessaires à l'analyse de votre demande
                  de financement
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className="container-app container-app-not-connected">
          <div className="wrap-steps-sidebar-not-connected">
            <div className="steps-sidebar-not-connected  visited">
              1. Informations Clients
              <RiCheckLine />
            </div>

            <div className="steps-sidebar-not-connected active">
              2. Documents à Joindre
            </div>
            <div className="steps-sidebar-not-connected">3. Récapitulatif</div>
          </div>
          <Row>
            <Col md={8}>
              <div className="wrap-financing-request">
                <form
                  className="register-form"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="step-financing-request">
                    {requestType === "farmer" && (
                      <>
                        {fileNameDropzone.attestation_agriculture ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Attestation d'agriculture UTAP ou SYNAGRI
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.attestation_agriculture ||
                                      ""
                                  )}
                                  {fileNameDropzone.attestation_agriculture}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("attestation_agriculture")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Attestation d'agriculture UTAP ou SYNAGRI"
                              name="attestation_agriculture"
                              hasError={
                                formErrorMessages.attestation_agriculture
                              }
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.attestation_agriculture}
                                </div>
                              }
                              value={valRegister.attestation_agriculture || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "attestation_agriculture"
                                  );
                              }}
                              required
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}

                    {fileNameDropzone.cin ? (
                      <>
                        <div className="wrap-result-files">
                          <label className="dropzone-component-label">
                            CIN
                          </label>
                          <div className="wrap-link-files">
                            <div className="wrap-name-files">
                              {FileExtImg(fileNameDropzone.cin || "")}
                              {fileNameDropzone.cin}
                            </div>
                            <RiDeleteBinLine
                              onClick={() => removeElement("cin")}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <Dropzone
                          label={
                            requestType === "company"
                              ? "CIN du gérant, des associés pour les SARL"
                              : "CIN"
                          }
                          name="cin"
                          hasError={formErrorMessages.cin}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.cin}
                            </div>
                          }
                          value={valRegister.cin || []}
                          onChange={(files) => {
                            files[0] && convertFileToBase64(files[0], "cin");
                          }}
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      </>
                    )}

                    {requestType === "farmer" && (
                      <>
                        {fileNameDropzone.titre_de_propriete ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Titre de propriété agricole
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.titre_de_propriete || ""
                                  )}
                                  {fileNameDropzone.titre_de_propriete}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("titre_de_propriete")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Titre de propriété agricole"
                              name="titre_de_propriete"
                              hasError={formErrorMessages.titre_de_propriete}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.titre_de_propriete}
                                </div>
                              }
                              value={valRegister.titre_de_propriete || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "titre_de_propriete"
                                  );
                              }}
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}

                    {requestType !== "farmer" && (
                      <>
                        {fileNameDropzone.patente ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Patente
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(fileNameDropzone.patente || "")}
                                  {fileNameDropzone.patente}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() => removeElement("patente")}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Patente"
                              name="patente"
                              hasError={formErrorMessages.patente}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.patente}
                                </div>
                              }
                              value={valRegister.patente || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(files[0], "patente");
                              }}
                              required
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}

                    {fileNameDropzone.facture_proforma ? (
                      <>
                        <div className="wrap-result-files">
                          <label className="dropzone-component-label">
                            Facture PROFORMA
                          </label>
                          <div className="wrap-link-files">
                            <div className="wrap-name-files">
                              {FileExtImg(
                                fileNameDropzone.facture_proforma || ""
                              )}
                              {fileNameDropzone.facture_proforma}
                            </div>
                            <RiDeleteBinLine
                              onClick={() => removeElement("facture_proforma")}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <Dropzone
                          label="Facture PROFORMA"
                          name="facture_proforma"
                          hasError={formErrorMessages.facture_proforma}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.facture_proforma}
                            </div>
                          }
                          value={valRegister.facture_proforma || []}
                          onChange={(files) => {
                            files[0] &&
                              convertFileToBase64(files[0], "facture_proforma");
                          }}
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      </>
                    )}

                    {requestType === "company" && (
                      <>
                        {fileNameDropzone.statuts_a_jour ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Statuts à jour et Procès-verbal (Si
                                modifications statutaires)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.statuts_a_jour || ""
                                  )}
                                  {fileNameDropzone.statuts_a_jour}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("statuts_a_jour")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Statuts à jour et Procès-verbal (Si modifications statutaires)"
                              name="statuts_a_jour"
                              hasError={formErrorMessages.statuts_a_jour}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.statuts_a_jour}
                                </div>
                              }
                              value={valRegister.statuts_a_jour || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "statuts_a_jour"
                                  );
                              }}
                              required
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}

                        {fileNameDropzone.repartition_du_capital ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Répartition du Capital (pour SA)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.repartition_du_capital ||
                                      ""
                                  )}
                                  {fileNameDropzone.repartition_du_capital}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("repartition_du_capital")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Répartition du Capital (pour SA)"
                              name="repartition_du_capital"
                              hasError={
                                formErrorMessages.repartition_du_capital
                              }
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.repartition_du_capital}
                                </div>
                              }
                              value={valRegister.repartition_du_capital || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "repartition_du_capital"
                                  );
                              }}
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}

                        {fileNameDropzone.pouvoirs_du_gerant ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Pouvoirs du/des Gérants ou DG ou PDG (pour SA)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.pouvoirs_du_gerant || ""
                                  )}
                                  {fileNameDropzone.pouvoirs_du_gerant}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("pouvoirs_du_gerant")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Pouvoirs du/des Gérants ou DG ou PDG (pour SA)"
                              name="pouvoirs_du_gerant"
                              hasError={formErrorMessages.pouvoirs_du_gerant}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.pouvoirs_du_gerant}
                                </div>
                              }
                              value={valRegister.pouvoirs_du_gerant || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "pouvoirs_du_gerant"
                                  );
                              }}
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}
                    {requestType === "professional" && (
                      <>
                        {fileNameDropzone.carte_professionnelle ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Carte Professionnelle (pour les professions
                                libérales)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.carte_professionnelle || ""
                                  )}
                                  {fileNameDropzone.carte_professionnelle}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("carte_professionnelle")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Carte Professionnelle (Obligatoire pour les professions libérales)"
                              name="carte_professionnelle"
                              hasError={formErrorMessages.carte_professionnelle}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.carte_professionnelle}
                                </div>
                              }
                              value={valRegister.carte_professionnelle || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "carte_professionnelle"
                                  );
                              }}
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}
                    {requestType !== "farmer" && (
                      <>
                        {fileNameDropzone.rne ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Registre National des Entreprises (datant de
                                moins de 03mois)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(fileNameDropzone.rne || "")}
                                  {fileNameDropzone.rne}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() => removeElement("rne")}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Registre National des Entreprises (datant de moins de 03mois)"
                              name="rne"
                              hasError={formErrorMessages.rne}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.rne}
                                </div>
                              }
                              value={valRegister.rne || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(files[0], "rne");
                              }}
                              required
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}

                    {fileNameDropzone.releves_bancaires ? (
                      <>
                        <div className="wrap-result-files">
                          <label className="dropzone-component-label">
                            {requestType === "farmer"
                              ? "Relevés bancaires des 06 derniers mois (Courant / Epargne)"
                              : "Relevés bancaires des 03 derniers mois"}
                          </label>
                          <div className="wrap-link-files">
                            <div className="wrap-name-files">
                              {FileExtImg(
                                fileNameDropzone.releves_bancaires || ""
                              )}
                              {fileNameDropzone.releves_bancaires}
                            </div>
                            <RiDeleteBinLine
                              onClick={() => removeElement("releves_bancaires")}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <Dropzone
                          label={
                            requestType === "farmer"
                              ? "Relevés bancaires des 06 derniers mois (Courant / Epargne)"
                              : "Relevés bancaires des 03 derniers mois"
                          }
                          name="releves_bancaires"
                          hasError={formErrorMessages.releves_bancaires}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.releves_bancaires}
                            </div>
                          }
                          value={valRegister.releves_bancaires || []}
                          onChange={(files) => {
                            files[0] &&
                              convertFileToBase64(
                                files[0],
                                "releves_bancaires"
                              );
                          }}
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      </>
                    )}

                    {requestType === "company" && (
                      <>
                        {fileNameDropzone.bilans_et_comptes_annexes ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Bilans et Comptes Annexes des 3 derniers
                                exercices (Rapports CAC pour les SA)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.bilans_et_comptes_annexes ||
                                      ""
                                  )}
                                  {fileNameDropzone.bilans_et_comptes_annexes}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("bilans_et_comptes_annexes")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Bilans et Comptes Annexes des 3 derniers exercices (Rapports CAC pour les SA)"
                              name="bilans_et_comptes_annexes"
                              hasError={
                                formErrorMessages.bilans_et_comptes_annexes
                              }
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.bilans_et_comptes_annexes}
                                </div>
                              }
                              value={
                                valRegister.bilans_et_comptes_annexes || []
                              }
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "bilans_et_comptes_annexes"
                                  );
                              }}
                              required
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}
                    {requestType === "farmer" && (
                      <>
                        {fileNameDropzone.taxe_de_transport ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Taxe de transport agricole ou carte grise de
                                matériel agricole (Si pas de relevés bancaires)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.taxe_de_transport || ""
                                  )}
                                  {fileNameDropzone.taxe_de_transport}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("taxe_de_transport")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Taxe de transport agricole ou carte grise de matériel agricole (Si pas de relevés bancaires)"
                              name="taxe_de_transport"
                              hasError={formErrorMessages.taxe_de_transport}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.taxe_de_transport}
                                </div>
                              }
                              value={valRegister.taxe_de_transport || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "taxe_de_transport"
                                  );
                              }}
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}
                    {requestType !== "company" && (
                      <>
                        {fileNameDropzone.facture_sone_de_steg ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Facture SONEDE/STEG
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.facture_sone_de_steg || ""
                                  )}
                                  {fileNameDropzone.facture_sone_de_steg}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("facture_sone_de_steg")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Facture SONEDE/STEG"
                              name="facture_sone_de_steg"
                              hasError={formErrorMessages.facture_sone_de_steg}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.facture_sone_de_steg}
                                </div>
                              }
                              value={valRegister.facture_sone_de_steg || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "facture_sone_de_steg"
                                  );
                              }}
                              required
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}
                    {requestType === "professional" && (
                      <>
                        {fileNameDropzone.certificat_de_degrevement_fiscal ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Certificat de dégrèvement fiscal (pour les Taxis
                                / Louages)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.certificat_de_degrevement_fiscal ||
                                      ""
                                  )}
                                  {
                                    fileNameDropzone.certificat_de_degrevement_fiscal
                                  }
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement(
                                      "certificat_de_degrevement_fiscal"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Certificat de dégrèvement fiscal (Obligatoire pour les Taxis/Louages)"
                              name="certificat_de_degrevement_fiscal"
                              hasError={
                                formErrorMessages.certificat_de_degrevement_fiscal
                              }
                              errorMessage={
                                <div className="text-danger">
                                  {
                                    formErrorMessages.certificat_de_degrevement_fiscal
                                  }
                                </div>
                              }
                              value={
                                valRegister.certificat_de_degrevement_fiscal ||
                                []
                              }
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "certificat_de_degrevement_fiscal"
                                  );
                              }}
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}

                        {fileNameDropzone.permis_de_conduire ? (
                          <>
                            <div className="wrap-result-files">
                              <label className="dropzone-component-label">
                                Permis de Conduire (pour les Taxis/Louages)
                              </label>
                              <div className="wrap-link-files">
                                <div className="wrap-name-files">
                                  {FileExtImg(
                                    fileNameDropzone.permis_de_conduire || ""
                                  )}
                                  {fileNameDropzone.permis_de_conduire}
                                </div>
                                <RiDeleteBinLine
                                  onClick={() =>
                                    removeElement("permis_de_conduire")
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Dropzone
                              label="Permis de Conduire (Obligatoire pour les Taxis/Louages)"
                              name="permis_de_conduire"
                              hasError={formErrorMessages.permis_de_conduire}
                              errorMessage={
                                <div className="text-danger">
                                  {formErrorMessages.permis_de_conduire}
                                </div>
                              }
                              value={valRegister.permis_de_conduire || []}
                              onChange={(files) => {
                                files[0] &&
                                  convertFileToBase64(
                                    files[0],
                                    "permis_de_conduire"
                                  );
                              }}
                              accept="image/*,.pdf"
                              description={
                                <>
                                  Cette dropzone accepte les fichiers de type
                                  <b> png, jpg, jpeg, pdf</b>
                                </>
                              }
                            />
                          </>
                        )}
                      </>
                    )}

                    {fileNameDropzone.rib ? (
                      <>
                        <div className="wrap-result-files">
                          <label className="dropzone-component-label">
                            RIB
                          </label>
                          <div className="wrap-link-files">
                            <div className="wrap-name-files">
                              {FileExtImg(fileNameDropzone.rib || "")}
                              {fileNameDropzone.rib}
                            </div>
                            <RiDeleteBinLine
                              onClick={() => removeElement("rib")}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <Dropzone
                          label="RIB"
                          name="rib"
                          hasError={formErrorMessages.rib}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.rib}
                            </div>
                          }
                          value={valRegister.rib || []}
                          onChange={(files) => {
                            files[0] && convertFileToBase64(files[0], "rib");
                          }}
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      </>
                    )}
                  </div>

                  <div className="wrap-btn-action-request">
                    <Button variant="light" size="lg">
                      <Link to="/customer-information" className="link-back">
                        <RiArrowLeftLine />
                        Précedent
                      </Link>
                    </Button>
                    <Button type="submit" size="lg">
                      Suivant
                    </Button>
                  </div>
                </form>
              </div>
            </Col>
            <Col md={4}>
              <SidebarRightFinancingRequestNotConnected />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default FinancingRequestNotConnectedStep2;
